function toDateOnly(input) {
  if (!input) return null;
  if (input instanceof Date) {
    const y = input.getFullYear();
    const m = String(input.getMonth() + 1).padStart(2, "0");
    const d = String(input.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  }
  return String(input).split("T")[0];
}

export function isWithinContractAndProjectPeriod(contract, dateToCheck) {
  if (!contract) {
    return { valid: false, reason: "Contrato não encontrado" };
  }

  const target = toDateOnly(dateToCheck);
  if (!target) {
    return { valid: false, reason: "Data inválida" };
  }

  const contractStart = toDateOnly(contract.start_date);
  const contractEnd = toDateOnly(contract.renewal_date);

  if (contractStart && target < contractStart) {
    return { valid: false, reason: "Data anterior ao início do contrato" };
  }
  if (contractEnd && target > contractEnd) {
    return { valid: false, reason: "Data posterior ao término do contrato" };
  }

  const project = contract.project;
  if (project) {
    const projectStart = toDateOnly(project.start_date);
    const projectEnd = toDateOnly(project.end_date);

    if (projectStart && target < projectStart) {
      return { valid: false, reason: "Data anterior ao início do projeto" };
    }
    if (projectEnd && target > projectEnd) {
      return { valid: false, reason: "Data posterior ao término do projeto" };
    }
  }

  return { valid: true };
}

export function rangeIntersectsContractAndProjectPeriod(contract, rangeStart, rangeEnd) {
  if (!contract) {
    return { valid: false, reason: "Contrato não encontrado" };
  }

  const start = toDateOnly(rangeStart);
  const end = toDateOnly(rangeEnd);
  if (!start || !end) {
    return { valid: false, reason: "Intervalo inválido" };
  }

  const contractStart = toDateOnly(contract.start_date);
  const contractEnd = toDateOnly(contract.renewal_date);

  if (contractStart && end < contractStart) {
    return { valid: false, reason: "Período anterior ao início do contrato" };
  }
  if (contractEnd && start > contractEnd) {
    return { valid: false, reason: "Período posterior ao término do contrato" };
  }

  const project = contract.project;
  if (project) {
    const projectStart = toDateOnly(project.start_date);
    const projectEnd = toDateOnly(project.end_date);

    if (projectStart && end < projectStart) {
      return { valid: false, reason: "Período anterior ao início do projeto" };
    }
    if (projectEnd && start > projectEnd) {
      return { valid: false, reason: "Período posterior ao término do projeto" };
    }
  }

  return { valid: true };
}

export function firstDayOfMonth(month, year) {
  return new Date(year, month - 1, 1);
}

export function lastDayOfMonth(month, year) {
  return new Date(year, month, 0);
}
